export default {
      id: "triangle-usage",
      viewBox: "0 0 10 9",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#triangle",
      toString: function () {
        return this.url;
      }
    }